import styled from 'styled-components';

export const StatusCardStyled = styled.div`

    .statusContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 94%;
        padding: 0 8px;

        .dottedLine {
            border: 1px dashed ${(props) => props.theme.color.border};
            width: 100%;
            margin-bottom: 24px;
        }

        .statusInner {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 15px;
            font-wieght: 600;
            width: 55px;   

            .active {
              color: #031A32;
              font-weight: 600;
            }

            .stretched {
                width: 110px;
            }

            .disabled {
                color: #78909C;
            }
        }
    }

    .statusTime {
        color: ${(props) => props.theme.grey.dark};
        font-weight: 600;
        font-size: 12px;
        div {
            &:last-child {
                text-align: center;
                width: 65px;
            }
        }
    }

    .statusMessage {
        background: ${(props) => props?.theme?.grey?.greyF4};
        font-size: 15px;
        font-weight: 600;
        padding: 16px;
        border-radius: 8px;
        margin-top: 1rem;
    }
`;